import { render } from "./OrderList.vue?vue&type=template&id=fee524e0&scoped=true"
import script from "./OrderList.vue?vue&type=script&lang=js"
export * from "./OrderList.vue?vue&type=script&lang=js"

import "./OrderList.vue?vue&type=style&index=0&id=fee524e0&lang=css"
import "./OrderList.vue?vue&type=style&index=1&id=fee524e0&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/admin-tmp/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fee524e0"]])

export default __exports__